<template>
  <LoadingDiv v-if="!isReady" />

  <div class="card" v-else>
    <div class="card-panel center">
      All (Staff & Dependants)
      <a href="#" class="edit-item" @click.prevent="handleDownload('all')"><i
          class="material-icons grey-text">download</i></a>
    </div>
    <div class="card-panel center">
      Staff only
      <a href="#" class="edit-item" @click.prevent="handleDownload('principals')"><i
          class="material-icons grey-text">download</i></a>
    </div>
    <!-- <div class="card-panel center">
      Dependants only
      <a
        href="#"
        class="edit-item"
        @click.prevent="handleDownload('dependants')"
        ><i class="material-icons grey-text">download</i></a
      >
    </div> -->
  </div>
</template>


<script>
import { ref, onMounted } from "vue";
import getItem from "@/composables/getItem";
import LoadingDiv from "@/components/LoadingDiv.vue";
import {
  downloadExcelFx,
} from "@/composables/reportFunction/downloader";
import nativeUi from "@/ui/native-ui";


export default {
  name: "EnrolleeDownloadComponent",
  components: { LoadingDiv },
  props: ["clientId"],
  setup(props) {
    const isReady = ref(false);
    const response = ref(null);

    // Get client
    onMounted(() => {
      // get 
      // principals
      // spouse
      // dependants
      getAll();
    });

    // handle
    const handleDownload = (val) => {
      // start
      let enrollee = null;
      let enrollees = [];
      
      // clear first
      if (val) {
        if (response.value) {
          response.value.active.forEach(principal => {
            // load principal
            if (principal) {
              enrollee = principal;
              enrollee.label = "Principal";
              enrollee.status = "Active";
              enrollee.planName = principal.plan?.name;
              enrollee.clientName = principal.client?.name;
              enrollees.push(enrollee);
            }

            if (val === "all") {
            // load spouse
            if (principal.spouse) {
              enrollee = principal.spouse;
              enrollee.label = "Spouse";
              enrollee.status = "Active";
              enrollee.planName = principal.plan?.name;
              enrollee.clientName = principal.client?.name;
              enrollee.type = "";
              enrollees.push(enrollee);
            }
            // load dependants
            if (principal.dependants.length) {
              principal.dependants.forEach(dependant => {
                if (dependant) {
                  enrollee = dependant;
                  enrollee.label = "Dependant";
                  enrollee.status = "Active";
                  enrollee.planName = principal.plan?.name;
                  enrollee.clientName = principal.client?.name;
                  enrollee.type = "";
                  enrollees.push(enrollee);
                }
              });
            }
          }
          });
           response.value.pending.forEach(principal => {
            // load principal
            if (principal) {
              enrollee = principal;
              enrollee.label = "Principal";
              enrollee.status = "Pending Payment Approval";
              enrollee.planName = principal.plan?.name;
              enrollee.clientName = principal.client?.name;
              enrollees.push(enrollee);
            }

            if (val === "all") {
            // load spouse
            if (principal.spouse) {
              enrollee = principal.spouse;
              enrollee.label = "Spouse";
              enrollee.status = "Pending Payment Approval";
              enrollee.planName = principal.plan?.name;
              enrollee.clientName = principal.client?.name;
              enrollee.type = "";
              enrollees.push(enrollee);
            }
            // load dependants
            if (principal.dependants.length) {
              principal.dependants.forEach(dependant => {
                if (dependant) {
                  enrollee = dependant;
                  enrollee.label = "Dependant";
                  enrollee.status = "Pending Payment Approval";
                  enrollee.planName = principal.plan?.name;
                  enrollee.clientName = principal.client?.name;
                  enrollee.type = "";
                  enrollees.push(enrollee);
                }
              });
            }
          }
          });
           response.value.lobby.forEach(principal => {
            // load principal
            if (principal) {
              enrollee = principal;
              enrollee.label = "Principal";
              enrollee.status = "Lobby (Billing)";
              enrollee.planName = principal.plan?.name;
              enrollee.clientName = principal.client?.name;
              enrollees.push(enrollee);
            }

            if (val === "all") {
            // load spouse
            if (principal.spouse) {
              enrollee = principal.spouse;
              enrollee.label = "Spouse";
              enrollee.status = "Lobby (Billing)";
              enrollee.planName = principal.plan?.name;
              enrollee.clientName = principal.client?.name;
              enrollee.type = "";
              enrollees.push(enrollee);
            }
            // load dependants
            if (principal.dependants.length) {
              principal.dependants.forEach(dependant => {
                if (dependant) {
                  enrollee = dependant;
                  enrollee.label = "Dependant";
                  enrollee.status = "Lobby (Billing)";
                  enrollee.planName = principal.plan?.name;
                  enrollee.clientName = principal.client?.name;
                  enrollee.type = "";
                  enrollees.push(enrollee);
                }
              });
            }
          } 
          });
           response.value.bin.forEach(principal => {
            // load principal
            if (principal) {
              enrollee = principal;
              enrollee.label = "Principal";
              enrollee.status = "Deleted";
              enrollee.planName = principal.plan?.name;
              enrollee.clientName = principal.client?.name;
              enrollees.push(enrollee);
            }

            if (val === "all") {
            // load spouse
            if (principal.spouse) {
              enrollee = principal.spouse;
              enrollee.label = "Spouse";
              enrollee.status = "Deleted";
              enrollee.planName = principal.plan?.name;
              enrollee.clientName = principal.client?.name;
              enrollee.type = "";
              enrollees.push(enrollee);
            }
            // load dependants
            if (principal.dependants.length) {
              principal.dependants.forEach(dependant => {
                if (dependant) {
                  enrollee = dependant;
                  enrollee.label = "Dependant";
                  enrollee.status = "Deleted";
                  enrollee.planName = principal.plan?.name;
                  enrollee.clientName = principal.client?.name;
                  enrollee.type = "";
                  enrollees.push(enrollee);
                }
              });
            }
          } 
          });
        }
      }

      if (enrollees.length) {
        // set client name
        let clientName = enrollees[0].clientName;
        // set downloadType
        let downloadType = val?.toUpperCase();
        // call downloader
        downloader(enrollees, downloadType, clientName);
      }
    };

    // downloader
    const downloader = (enrollees, downloadType, clientName) => {

      // start
      let data = [];

      // load
      enrollees.forEach((enrollee, number) => {

        data.push({
          No: number + 1,
          Client: enrollee.clientName,
          type: enrollee.type == "" ? "" : enrollee.type == "i" ? "Individual" : `Family - ${enrollee.label}`,
          Name: enrollee.name,
          ID: enrollee.enrollee_number,
          Sex: enrollee.sex == "" ? "Not Specified" : enrollee.sex == "m" ? "Male" : "Female",
          DOB: enrollee.dob,
          Phone: enrollee.phone,
          Address: enrollee.address,
          Plan: enrollee.planName,
          Status: enrollee.status,
        })

      })


      // space
      data.push({})
      // space
      data.push({})

      // final
      if (data.length) {

        // notify (Toast)
        nativeUi.toast({
          html: "Client Downloading <i class='material-icons'>check_circle</i>", // Toast content
          // classes: 'green rounded', // Add custom classes
          displayLength: 5000, // Duration in milliseconds
          inDuration: 300, // Transition in duration
          outDuration: 300, // Transition out duration
        });

        // today
        const today = new Date().toLocaleDateString('en-GB').split('/').join('_');

        // fire function
        return downloadExcelFx(data, `${clientName}_${downloadType}_${today}`);

      }

    }

    // get client
    const getAll = () => {
      (async () => {
        const { res } = await getItem("principal/client/download", props.clientId);

        if (res.value) {
          response.value = res.value.data;
        }

        // ready
        isReady.value = true;
      })();
    };

    return {
      isReady,
      handleDownload,
    };
  },
};
</script>


<style scoped>
.spacer10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.pointer {
  cursor: default;
}

.edit-item:hover .material-icons.grey-text,
.edit-item:hover .material-icons.grey-text::before {
  color: rgb(21, 21, 206) !important;
}
</style>